/**
 * A parallel to staticPageUrls.  Use these functions for dynamic routes in place
 * of constructing them on the fly.
 */

/**
 * Construct the route for a given campus's information page
 * @param campusId The campus to get the information page for
 * @returns The relative route for the campus information
 */
const makeCampusInfoUrl = (campusId: string) => {
	return `/campus/${campusId}`;
};

/**
 * Construct the route for a given campus's tuition page
 * @param campusId The campus to get the tuition page for
 * @returns The relative route for the campus's tuition page
 */
const makeCampusTuitionUrl = (campusId: string) => {
	return `/campus/${campusId}/tuition`;
};

export {makeCampusInfoUrl, makeCampusTuitionUrl};
